// extracted by mini-css-extract-plugin
export default {"dropZoneBlock":"DropZone_dropZoneBlock__EQ6W6","dropDownTitle":"DropZone_dropDownTitle__99pHH"};